import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx, renderList as _renderList, createSlots as _createSlots } from "vue"

import KOAddress from './ko.vue';
  import JAAddress from './ja.vue';
  import { useI18n } from 'vue-i18n';
  import { useAttrs, useSlots } from 'vue';

  
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

  const attrs = useAttrs();
  const slots = useSlots();
  const { locale } = useI18n();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(locale) === 'ja' ? JAAddress : KOAddress), _normalizeProps(_guardReactiveProps(_unref(attrs))), _createSlots({ _: 2 }, [
    _renderList(_unref(slots), (slot, slotName) => {
      return {
        name: slotName,
        fn: _withCtx((scope) => [
          (_openBlock(), _createBlock(_resolveDynamicComponent(slot), _normalizeProps(_guardReactiveProps(scope)), null, 16))
        ])
      }
    })
  ]), 1040))
}
}

})